export const environment = {
    apiUrl: 'https://stageapi.call48.com/api',
    apiDocUrl: 'https://stageapi.call48.com/apidocs',
    mainPartitionUrl: 'stage.call48.com,stage.skyetel.com',
    paypalClientId: 'AbM_LGzYcJdwUHyY8ovmAbHwlj7vieLNEM9oaFqdRQaCXYT6mtHwQD1HSqUyZLKW3f55lkeOetaI2lli',
    accountBalanceUrl: 'https://uxc81p3vre.execute-api.us-east-2.amazonaws.com/v1/admin/accounts/balances',
    userAccountBalanceUrl: 'https://uxc81p3vre.execute-api.us-east-2.amazonaws.com/v1/accounts/balance',
    production: false,
    hmr: false,
    backend: false,
    staging: true,
};  